module.exports = __webpack_public_path__ + "static/hcpettreats4-2496d939b17ec13be07d801fb03faccf.jpg";